"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conversionRules = exports.convertToDocx = exports.convertToLaTeX = exports.convertToDocxDocumentXml = exports.convertToTEI = exports.convertToXML = exports.convertToHTML = exports.parse = exports.tokenize = void 0;
const KojiHTMLConverter_1 = require("./converter/KojiHTMLConverter");
const KojiAstBuilder_1 = require("./KojiAstBuilder");
const KojiParser_1 = require("./KojiParser");
const antlr4ts_1 = require("antlr4ts");
const KojiLexer_1 = require("./KojiLexer");
const KojiXMLConverter_1 = require("./converter/KojiXMLConverter");
const KojiDocxDocumentConverter_1 = require("./converter/KojiDocxDocumentConverter");
const inline_rules_1 = require("./converter/inline_rules");
const block_rules_1 = require("./converter/block_rules");
const KojiDocxCompiler_1 = require("./converter/KojiDocxCompiler");
const KojiLaTeXConverter_1 = require("./converter/KojiLaTeXConverter");
class AccumlateErrorListener {
    constructor() {
        this.errors = [];
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, exception) {
        //console.log(offendingSymbol);
        this.errors.push({ line, charPositionInLine, msg, offendingSymbol });
    }
}
function tokenize(input) {
    const is = new antlr4ts_1.ANTLRInputStream(input);
    const lexer = new KojiLexer_1.KojiLexer(is);
    const errorHandler = new AccumlateErrorListener();
    lexer.addErrorListener(errorHandler);
    const stream = new antlr4ts_1.CommonTokenStream(lexer);
    stream.fill();
    return { tokens: stream.getTokens(), errors: errorHandler.errors };
}
exports.tokenize = tokenize;
function parse(input) {
    const is = new antlr4ts_1.ANTLRInputStream(input);
    const lexer = new KojiLexer_1.KojiLexer(is);
    const ts = new antlr4ts_1.CommonTokenStream(lexer);
    const parser = new KojiParser_1.KojiParser(ts);
    const errorHandler = new AccumlateErrorListener();
    lexer.addErrorListener(errorHandler);
    parser.addErrorListener(errorHandler);
    const tree = parser.koji();
    const visitor = new KojiAstBuilder_1.KojiAstBuilder();
    const ast = visitor.visit(tree);
    const errors = errorHandler.errors;
    return { ast, errors };
}
exports.parse = parse;
function convertToHTML(ast, options) {
    const converter = new KojiHTMLConverter_1.KojiHTMLConverter(options);
    return converter.convert(ast);
}
exports.convertToHTML = convertToHTML;
function convertToXML(ast, options) {
    const converter = new KojiXMLConverter_1.KojiXMLConverter(options);
    return converter.convert(ast);
}
exports.convertToXML = convertToXML;
function convertToTEI(ast) {
    const xml = convertToXML(ast);
    return `<?xml version="1.0" encoding="UTF-8"?>
<?xml-model href="http://www.tei-c.org/release/xml/tei/custom/schema/relaxng/tei_all.rng" type="application/xml"
	schematypens="http://purl.oclc.org/dsdl/schematron"?>
<TEI xmlns="http://www.tei-c.org/ns/1.0">
   <teiHeader>
      <fileDesc>
         <titleStmt>
            <title>Title</title>
         </titleStmt>
         <publicationStmt>
            <p>Publication Information</p>
         </publicationStmt>
         <sourceDesc>
            <p>Information about the source</p>
         </sourceDesc>
      </fileDesc>
   </teiHeader>
   ${xml}
</TEI>
	`;
}
exports.convertToTEI = convertToTEI;
function convertToDocxDocumentXml(ast, options) {
    const converter = new KojiDocxDocumentConverter_1.KojiDocxDocumentConverter(options);
    return converter.convert(ast);
}
exports.convertToDocxDocumentXml = convertToDocxDocumentXml;
function convertToLaTeX(ast, options) {
    const converter = new KojiLaTeXConverter_1.KojiLaTeXConverter(options);
    return converter.convert(ast);
}
exports.convertToLaTeX = convertToLaTeX;
function convertToDocx(ast, type) {
    if (type === "blob") {
        return KojiDocxCompiler_1.toBlob(ast);
    }
    else if (type === "base64") {
        return KojiDocxCompiler_1.toBase64String(ast);
    }
    else if (type === "buffer") {
        return KojiDocxCompiler_1.toBuffer(ast);
    }
}
exports.convertToDocx = convertToDocx;
exports.conversionRules = {};
inline_rules_1.default.forEach((r) => (exports.conversionRules[r.elemName] = r));
block_rules_1.default.forEach((r) => (exports.conversionRules[r.elemName] = r));
//# sourceMappingURL=data:application/json;base64,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